import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
export function LoginPage() {
  return <div className="bg-black text-white min-h-screen" data-id="element-324">
      <Header data-id="element-325" />
      <main className="pt-20" data-id="element-326">
        <div className="container mx-auto px-4 py-16" data-id="element-327">
          <div className="max-w-md mx-auto" data-id="element-328">
            <h1 className="text-3xl font-bold mb-6 text-center" data-id="element-329">
              Welcome Back
            </h1>
            <div className="bg-zinc-900 p-8 rounded-lg" data-id="element-330">
              <form className="space-y-6" data-id="element-331">
                <div data-id="element-332">
                  <label htmlFor="email" className="block mb-2 text-gray-300" data-id="element-333">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full bg-zinc-800 border border-zinc-700 rounded-md py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="john@example.com" data-id="element-334" />
                </div>
                <div data-id="element-335">
                  <div className="flex justify-between items-center mb-2" data-id="element-336">
                    <label htmlFor="password" className="text-gray-300" data-id="element-337">
                      Password
                    </label>
                    <Link to="/forgot-password" className="text-sm text-red-500 hover:text-red-400" data-id="element-338">
                      Forgot Password?
                    </Link>
                  </div>
                  <input type="password" id="password" className="w-full bg-zinc-800 border border-zinc-700 rounded-md py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="••••••••" data-id="element-339" />
                </div>
                <div className="flex items-center" data-id="element-340">
                  <input type="checkbox" id="remember" className="h-4 w-4 border-gray-300 rounded text-red-600 focus:ring-red-600" data-id="element-341" />
                  <label htmlFor="remember" className="ml-2 block text-sm text-gray-300" data-id="element-342">
                    Remember me
                  </label>
                </div>
                <button type="submit" className="w-full bg-red-600 text-white py-3 rounded font-medium text-lg hover:bg-red-700 transition-colors" data-id="element-343">
                  Log In
                </button>
              </form>
              <div className="mt-6 text-center text-gray-400 text-sm" data-id="element-344">
                Don't have an account?{' '}
                <Link to="/signup" className="text-red-500 hover:text-red-400" data-id="element-345">
                  Sign up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-346" />
    </div>;
}